import { defineStore } from "pinia";
import { ref, computed } from "vue";
import axios from "axios";

export const useAuthStore = defineStore("auth", () => {
  const user = ref(null);
  const users = ref(null);
  const token = ref(localStorage.getItem("token"));

  const isAuthenticated = computed(() => !!token.value);

  const setToken = (newToken) => {
    token.value = newToken;
    if (newToken) {
      localStorage.setItem("token", newToken);
      axios.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
    } else {
      localStorage.removeItem("token");
      delete axios.defaults.headers.common["Authorization"];
    }
  };

  const setUser = (newUser) => {
    user.value = newUser;
  };

  const setUsers = (newUsers) => {
    users.value = newUsers;
  };

  const login = async (credentials) => {
    const response = await axios.post("/api/login", credentials);
    setToken(response.data.token);
    await fetchUser();
    return response;
  };

  const logout = async () => {
    try {
      await axios.post("/api/logout");
    } finally {
      setToken(null);
      setUser(null);
    }
  };

  const fetchUser = async () => {
    const response = await axios.get("/api/user");
    setUser(response.data.user);
    return response;
  };

  const fetchUsers = async () => {
    const response = await axios.get("/api/users");
    setUsers(response.data.data);
    return response;
  };

  // Initialize axios with token if it exists
  if (token.value) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token.value}`;
    fetchUser().catch(() => setToken(null));
  }

  return {
    login,
    logout,
    token,
    isAuthenticated,
    user,
    users,
    fetchUser,
    fetchUsers,
  };
});
